(() => {
  class TpReels extends HTMLElement {
    connectedCallback() {
      requestAnimationFrame(() => {
        this.initSwiper();
        this.initVideos();
      });
    }

    disconnectedCallback() {
      if (this.swiper) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
      if (this.videoObserver) {
        this.videoObserver.disconnect();
        this.videoObserver = null;
      }
    }

    initSwiper() {
      if (typeof Swiper === 'undefined') return;
      if (this.swiper) this.swiper.destroy(true, true);

      const swiperEl = this.querySelector('.tp-e-reels__swiper');
      if (!swiperEl) return;

      if (this.dataset.carouselLayout === 'coverflow') {
        this.initCoverflow(swiperEl);
        return;
      }

      this.swiper = new Swiper(swiperEl, {
        slidesPerView: 2.2,
        spaceBetween: 8,
        breakpoints: {
          750: { slidesPerView: 3, spaceBetween: 24 },
          1024: { slidesPerView: 4, spaceBetween: 24 },
          1280: { slidesPerView: 4, spaceBetween: 32 },
        },
      });
    }

    initCoverflow(swiperEl) {
      const wrapper = swiperEl.querySelector('.swiper-wrapper');
      const originalSlides = Array.from(wrapper.children);
      const total = originalSlides.length;
      if (total === 0) return;

      // Três cópias da lista para o carrossel parecer infinito nos dois sentidos.
      for (let copy = 0; copy < 3; copy += 1) {
        originalSlides.forEach((slide) => {
          const clone = slide.cloneNode(true);
          clone.removeAttribute('data-shopify-editor-block');
          wrapper.appendChild(clone);
        });
      }

      this.swiper = new Swiper(swiperEl, {
        slidesPerView: 1.35,
        spaceBetween: 14,
        centeredSlides: true,
        speed: 500,
        initialSlide: total,
        breakpoints: {
          750: { slidesPerView: 'auto', spaceBetween: 60 },
        },
      });

      const swiper = this.swiper;
      swiper.on('transitionEnd', () => {
        const index = swiper.activeIndex;
        if (index < total) {
          swiper.slideTo(index + total, 0, false);
        } else if (index >= total * 3) {
          swiper.slideTo(index - total, 0, false);
        }
      });

      swiperEl.addEventListener('click', (event) => {
        if (event.target.closest('.tp-e-reels__product-card')) return;
        const slide = event.target.closest('.swiper-slide');
        if (!slide || slide.classList.contains('swiper-slide-active')) return;
        const index = Array.from(wrapper.children).indexOf(slide);
        if (index !== -1) swiper.slideTo(index);
      });
    }

    initVideos() {
      const cards = Array.from(this.querySelectorAll('.tp-e-reels__card--video'));

      cards.forEach((card) => {
        card.addEventListener('click', () => {
          const video = card.querySelector('.tp-e-reels__video');
          if (!video) return;

          if (card.classList.contains('tp-e-reels__card--playing')) {
            video.pause();
            card.classList.remove('tp-e-reels__card--playing');
          } else {
            video.play();
            card.classList.add('tp-e-reels__card--playing');
          }
        });
      });

      if (this.dataset.autoplay !== 'true' || !('IntersectionObserver' in window)) return;

      this.videoObserver = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            const card = entry.target;
            const video = card.querySelector('.tp-e-reels__video');
            if (!video) return;

            if (entry.isIntersecting) {
              video.muted = true;
              const played = video.play();
              if (played && played.catch) played.catch(() => {});
              card.classList.add('tp-e-reels__card--playing');
            } else {
              video.pause();
              card.classList.remove('tp-e-reels__card--playing');
            }
          });
        },
        { threshold: 0.5 }
      );

      cards.forEach((card) => this.videoObserver.observe(card));
    }
  }

  if (!customElements.get('tp-reels')) customElements.define('tp-reels', TpReels);
})();
